/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable no-lone-blocks */

import { useState, useEffect } from "react";
import moment from "moment";

export function WelcomeByHour(now) {
  const [welcomeAM, setWelcomeAM] = useState(false);
  const [welcomePM, setWelcomePM] = useState(false);
  const amToPm = moment().hours(11).minutes(59).seconds(59);
  const pmToNight = moment().hours(18).minutes(59).seconds(59);
  const lastNightHour = moment().hours(5).minutes(59).seconds(59);

  useEffect(() => {
    if (now._d > amToPm._d && now._d < pmToNight._d) {
      setWelcomePM(true);
      setWelcomeAM(false);
    } else {
      if (now._d > pmToNight._d || now._d < lastNightHour._d) {
        setWelcomePM(false);
        setWelcomeAM(false);
      } else {
        setWelcomePM(false);
        setWelcomeAM(true);
      }
    }
  }, [now._d]);

  let welcome;

  {
    welcomeAM
      ? (welcome = <span>Buen día!</span>)
      : welcomePM
      ? (welcome = <span>Buenas tardes!</span>)
      : (welcome = <span>Buenas noches!</span>);
  }

  return `${welcome.props.children}`;
}

export function chartToMoney(amount) {
  return (
    "$ " +
    Math.trunc(amount * 1000000)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
  );
}

export function orderLabelsAndAmountsCurrent(data = []) {

  let labels = [];
  let amounts = [];
  const background = [];
  const currentYear = moment().year();
  let totalSelled = 0;
  if (data.length > 0) {
    data?.forEach((element) => {
      labels.push(element.label);
      amounts.push(element.sales);
      if (element.month.indexOf(currentYear)) {
 
        if(moment(element.month).year() - currentYear === -1) {
          background.push("#5A6E7F")
        }
        if(moment(element.month).year() - currentYear === -2) {
          background.push("#A8DAD5")
        }
       
      } else {
        totalSelled = totalSelled + element.sales;
        background.push("#E8534A")
      }
     
    });
  }
  return [{ labels, amounts, totalSelled, background }];
}

export function orderLabelsAndAmounts(data = []) {

  let labels = [];
  let amounts = [];
  const background = [];
  const currentYear = moment().year();
  let totalSelled = 0;
  if (data.length > 0) {
    data?.forEach((element) => {
      labels.push(element.label);
      amounts.push(element.sales);
      if (element.month.indexOf(currentYear)) {
        if(moment(element.month).year() - currentYear === -1) {
          background.push("#5A6E7F")
        }
        if(moment(element.month).year() - currentYear === -2) {
          background.push("#A8DAD5")
        }
       
      } else {
       
        background.push("#E8534A")
      }
      totalSelled = totalSelled + element.sales;
    });
  }
  return [{ labels, amounts, totalSelled, background }];
}

export function getPaimentData(data, client, filter) {
  let header = [];
  let legend = [];
  let companyName = [];
  let valid = 0;
  let expired30 = 0;
  let expired60 = 0;
  let expired90 = 0;
  let totalAmount = 0;
  let expiredOlder = 0;
  let filterData;
  let nameToShow;
  let barSelected = {status: false, bar: null}
  let entireAmount = 0;
  let currentPay = 0;
  let duePay = 0;

  if (data[0]) {
    if (client?.rut) {
      const clientName = client?.receiverName || client?.name;
      const clientOutsideProviderId = client?.outsideProviderId;
      const clientCompanyId = client?.companyId ? String(client.companyId) : null;

      filterData = data[0].filter((f) => {
        if (clientCompanyId && String(f.companyId || '') !== clientCompanyId) {
          return false;
        }
        if (clientOutsideProviderId && f.outsideProviderId) {
          return f.rut == client.rut && f.outsideProviderId == clientOutsideProviderId;
        }
        if (clientName) {
          return f.rut == client.rut && f.name == clientName;
        }
        return f.rut == client.rut;
      });
    }
    data[0]?.forEach((element) => {
      nameToShow = filterData?.length && filterData[0]?.name;
      const rowBase = {
        title: element.name,
        rut: element.rut,
        outsideProviderId: element.outsideProviderId,
        documents: element.documents,
        companyId: element.companyId,
      };
      if (!filter) {
        companyName.push({
          ...rowBase,
          amount:
            element.valid +
            element?.expired30 +
            element?.expired60 +
            element?.expired90 +
            element?.expiredOlder,
        });
        valid = filterData?.length ? filterData[0]?.valid : valid + element.valid;
        currentPay = filterData?.length ? filterData[0]?.valid : currentPay + element.valid;
        expired30 = filterData?.length
          ? filterData[0]?.expired30
          : expired30 + element?.expired30;
        expired60 = filterData?.length
          ? filterData[0]?.expired60
          : expired60 + element?.expired60;
        expired90 = filterData?.length
          ? filterData[0]?.expired90
          : expired90 + element?.expired90;
        expiredOlder = filterData?.length
          ? filterData[0]?.expiredOlder
          : expiredOlder + element?.expiredOlder;
        totalAmount =
          totalAmount +
          element?.valid +
          element?.expired30 +
          element?.expired60 +
          element?.expired90 +
          element?.expiredOlder;
        duePay =
        filterData?.length ?
        filterData[0]?.expired30 +
        filterData[0]?.expired60 +
        filterData[0]?.expired90 +
        filterData[0]?.expiredOlder :
        duePay +
        element?.expired30 +
        element?.expired60 +
        element?.expired90 +
        element?.expiredOlder;
    }
      if (filter) {
        barSelected = {status: true, bar: filter}
        currentPay = filterData?.length ? filterData[0]?.valid : currentPay + element.valid;
        duePay = filterData?.length ?
          filterData[0]?.expired30 +
          filterData[0]?.expired60 +
          filterData[0]?.expired90 +
          filterData[0]?.expiredOlder :
          duePay +
          element.expired30 +
          element.expired60 +
          element.expired90 +
          element.expiredOlder;
        switch (filter) {
          case "0":
            companyName.push({
              ...rowBase,
              amount: element.valid,
            });
            totalAmount = filterData?.length
        ? filterData[0].valid
              : valid + element.valid;
            valid = filterData?.length ? filterData[0].valid : valid + element.valid;
            break;
          case "1, 30":
            companyName.push({
              ...rowBase,
              amount: element.expired30,
            });
            totalAmount = filterData?.length
        ? filterData[0].expired30
              : expired30 + element.expired30;
            expired30 = filterData?.length
        ? filterData[0].expired30
              : expired30 + element.expired30;
            break;
          case "31, 60":
            companyName.push({
              ...rowBase,
              amount: element.expired60,
            });
            totalAmount = filterData?.length
        ? filterData[0].expired60
              : expired60 + element.expired60;
            expired60 = filterData?.length
        ? filterData[0].expired60
              : expired60 + element.expired60;
            break;
          case "61, 90":
            companyName.push({
              ...rowBase,
              amount: element.expired90,
            });
            totalAmount = filterData?.length
        ? filterData[0].expired90
              : totalAmount + element.expired90;
            expired90 = filterData?.length
        ? filterData[0].expired90
              : expired90 + element.expired90;
            break;
          case "91":
            companyName.push({
              ...rowBase,
              amount: element.expiredOlder,
            });
            totalAmount = filterData?.length
        ? filterData[0]?.expiredOlder
              : totalAmount + element?.expiredOlder;
            expiredOlder = filterData?.length
        ? filterData[0]?.expiredOlder
              : expiredOlder + element?.expiredOlder;
            break;
          default:
        }
      }
      if (filterData?.length && !filter) {
        nameToShow = filterData[0]?.name;
        totalAmount = 0;
        totalAmount =
          totalAmount +
          filterData[0]?.valid +
          filterData[0]?.expired30 +
          filterData[0]?.expired60 +
          filterData[0]?.expired90 +
          filterData[0]?.expiredOlder;
        currentPay = filterData?.length ? filterData[0]?.valid : currentPay + element.valid;
        duePay = 
          filterData?.length ?
          filterData[0]?.expired30 +
          filterData[0]?.expired60 +
          filterData[0]?.expired90 +
          filterData[0]?.expiredOlder :
          duePay +
          element.expired30 +
          element.expired60 +
          element.expired90 +
          element.expiredOlder;
      }
    });
    header = ["Razón Social", "Monto"];
    legend = [
      "Al día",
      "Atrasado entre 1 y 30 días",
      "Atrasado entre 31 y 60 días",
      "Atrasado entre 61 y 90 días",
      "Atrasado entre 90+ días",
    ];
  }
  entireAmount = currentPay + duePay

  const dashboardData = [
    {
      valid,
      expired30,
      expired60,
      expired90,
      totalAmount,
      expiredOlder,
      nameToShow,
      barSelected,
      entireAmount,
      currentPay,
      duePay
    },
  ];

  companyName.sort((a, b) => {
    if (a.amount < b.amount) {
      return 1;
    } else if (a.amount > b.amount) {
      return -1;
    } else {
      return 0;
    }
  });

  return [{ header, legend, companyName, dashboardData }];
}

export function getLiquidezDashboard(data, column, type) {
  const general = { borderWidth: 2, lineTension: 0, fill: false };
  const closingBalanceColor = "#F5A623";
  const closingBalanceOptions = {
    type: "line",
    label: "Saldo",
    backgroundColor: closingBalanceColor,
    borderColor: closingBalanceColor,
    data: [],
    ...general,
  };
  const totalIncomeColor = "#7EC8C0";
  const totalIncomeOptions = {
    type: "bar",
    label: "Ingresos",
    backgroundColor: totalIncomeColor,
    borderColor: totalIncomeColor,
    data: [],
    ...general,
  };
  const outflowColor = "#E8534A";
  const outflowOptions = {
    type: "bar",
    label: "Egresos",
    backgroundColor: outflowColor,
    borderColor: outflowColor,
    data: [],
    ...general,
  };
  let labels = [];
  let datasets = [];
  if (data) {
    if (column + 8 < data.length) data = data.slice(column, column + 8);
    else data = data.slice(data.length - 8, data.length);
    const format =
      type == "month"
        ? "MMM-YYYY"
        : type == "week"
        ? "DD/MM/YYYY"
        : type == "day"
        ? "DD/MM/YYYY"
        : null;
    labels.push(...data.map((d) => moment(d.startDate).format(format)));

    if (data.length > 0) {
      data.forEach((element) => {
        totalIncomeOptions.data.push(element.totalIncome / 1000000);
        outflowOptions.data.push(-element.outflows / 1000000);
        closingBalanceOptions.data.push(element.closingBalance / 1000000);
      });
      datasets = [closingBalanceOptions, totalIncomeOptions, outflowOptions];
    }
  }
  return [{ datasets, labels }];
}
